import apiClient from './apiClient';

const BASE = '/api/v1.0/operator/ai-keys';

/**
 * Operator-only (SUPER_ADMIN) platform AI key. The GET returns a MASKED view;
 * on PUT, a blank apiKey leaves the stored key unchanged.
 */
const operatorAiKeysApi = {
  get: async () => {
    const r = await apiClient.get(BASE);
    return r.data?.data || r.data;
  },
  update: async (payload) => {
    const r = await apiClient.put(BASE, payload);
    return r.data?.data || r.data;
  },
};

export default operatorAiKeysApi;
